import { format, isValid, parse, startOfDay } from 'date-fns';
import type { LocalDate } from '@zg-rentals/ts-renter-info-client';

export const DATE_FORMAT = 'MM/dd/yyyy';
export const MONTHS_PER_YEAR = 12;

export const isLocalDateInPast = (date: LocalDate): boolean =>
  new Date(date.year, date.month - 1, date.day) < startOfDay(new Date());

export const localDateToString = (date: LocalDate | undefined): string | null => {
  if (!date) return null;
  return format(new Date(date.year, date.month - 1, date.day), DATE_FORMAT);
};

export const stringToLocalDate = (value: string | null): LocalDate | undefined => {
  if (!value) return undefined;
  const parsed = parse(value, DATE_FORMAT, new Date());
  if (!isValid(parsed)) return undefined;
  return { year: parsed.getFullYear(), month: parsed.getMonth() + 1, day: parsed.getDate() };
};
